/* Konfigurator C+ - palety kolorow RAL / ICA / Farrow & Ball (redesign 2026-09-24).
   Nie ma wlasnej logiki zamowienia: wybor z palety uruchamia istniejacy tryb „Dowolny kolor”
   konfiguratora (kafelek .knf__color--custom + pole [data-knf-kolor-custom]), wiec kolor trafia
   do koszyka i do _pl_summary dokladnie tak, jak wpisany recznie. Dane palet (knf-palety.json)
   laduja sie dopiero po otwarciu zakladki albo w wolnej chwili, gdy przywrocony kolor jest z palety. */
(function () {
  const root = document.querySelector("[data-knf]");
  const tabs = root && root.querySelector("[data-knf-paltabs]");
  const panel = root && root.querySelector("[data-knf-pal]");
  if (!tabs || !panel) return;
  const fs = tabs.closest("[data-knf-fs-kolor]");
  const colorsWrap = root.querySelector("[data-knf-colors]");
  const grid = panel.querySelector("[data-knf-pal-grid]");
  const famWrap = panel.querySelector("[data-knf-pal-fam]");
  const q = panel.querySelector("[data-knf-pal-q]");
  const pick = panel.querySelector("[data-knf-pal-pick]");
  const locale = root.dataset.locale || "pl";
  const T = JSON.parse(panel.dataset.i18n || "{}");
  let data = null, loading = null, tab = "base", fam = "", lastPicked = "";

  const norm = s => String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/ł/g, "l").replace(/\s+/g, " ").trim();
  const nameOf = it => (locale !== "pl" && it["n_" + locale]) || it.n || "";
  // wer2 24.09: F&B z nazwa palety (kody „No. 30” sa niejednoznaczne dla produkcji); labelPl idzie do _pl_summary
  const PFX = { fb: "Farrow & Ball ", ncs: "NCS " };   // nazwa palety w zamowieniu (kody F&B „No. 30” i NCS „S 1050-Y90R” bez niej sa niejednoznaczne)
  const label = (key, it) => `${PFX[key] || ""}${it.k}${nameOf(it) ? " " + nameOf(it) : ""}`;
  const labelPl = (key, it) => `${PFX[key] || ""}${it.k}${it.n ? " " + it.n : ""}`;
  const LIST = ["ral", "ncs", "ica", "fb"];
  const lum = h => { const n = parseInt(h.slice(1), 16); return .299 * (n >> 16) + .587 * (n >> 8 & 255) + .114 * (n & 255); };
  const esc = v => String(v || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  const reEsc = v => v.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  function load() {
    if (data) return Promise.resolve(data);
    if (!loading) loading = fetch(panel.dataset.src, { credentials: "omit" }).then(r => r.json()).then(j => (data = j)).catch(() => (loading = null, null));
    return loading;
  }
  // NCS (ok. 2000 odcieni) w osobnym pliku - pobierany dopiero po otwarciu zakladki NCS albo przy przywracaniu koloru NCS
  let loadingNcs = null;
  function loadFor(t) {
    if (t !== "ncs") return load();
    return load().then(d => {
      if (!d || d.ncs || !panel.dataset.srcNcs) return d;
      if (!loadingNcs) loadingNcs = fetch(panel.dataset.srcNcs, { credentials: "omit" }).then(r => r.json()).then(j => { Object.assign(d, j); return d; }).catch(() => (loadingNcs = null, d));
      return loadingNcs;
    });
  }
  // dla rysunku (knf-rysunek.js): hex dla wpisanego tekstu, jesli pasuje do pozycji palety
  window.knfPalHex = text => {
    if (!data || !text) return "";
    const t = norm(text);
    for (const key of LIST) {
      const list = (data[key] && data[key].items) || [];
      for (const it of list) {
        const code = norm(it.k), full = norm(label(key, it));
        if (t === full || t === code || t.startsWith(code + " ")) return it.h;
        // wer2 24.09: „Haystack” lapal F&B „Hay” - nazwa tylko jako cale slowa i tylko przy wzmiance o F&B albo numerze „No.”
        if (key === "fb" && norm(it.n) && (t.includes("farrow") || /(^|\s)f ?& ?b(\s|$)/.test(t) || /(^|\s)no\.? ?\d/.test(t))
          && new RegExp(`(^|[^a-z0-9])${reEsc(norm(it.n))}([^a-z0-9]|$)`).test(t)) return it.h;
      }
    }
    return "";
  };

  function customTile() { return root.querySelector('.knf__color--custom[data-color="__custom__"]'); }
  function input() { return root.querySelector("[data-knf-kolor-custom]"); }

  function setTab(t, silent) {
    tab = t;
    tabs.querySelectorAll("[data-pal]").forEach(b => b.setAttribute("aria-selected", String(b.dataset.pal === t)));
    const list = LIST.includes(t);
    fs.classList.toggle("knf--pal-list", list);
    fs.classList.toggle("knf--pal-code", t === "code");
    panel.hidden = !list;
    if (list) {
      fam = ""; if (q) q.value = "";
      if (!data || !data[t]) grid.innerHTML = "";
      loadFor(t).then(d => {
        // 24.09 (Konrad): nie pokazujemy od razu wszystkich kolorow - najpierw rodziny; wybrany wczesniej kolor otwiera swoja rodzine
        const cur = norm(input() ? input().value : ""), hit = cur && d && d[t] && d[t].items.find(it => norm(label(t, it)) === cur);
        if (hit && hit.g) fam = hit.g;
        render();
      });
    }
    if (t === "code" && !silent) {
      // wer2 24.09: samo otwarcie zakladki nie zmienia koloru; tryb „Dowolny kolor” wlacza pierwszy wpisany znak (listener input nizej)
      const cw = root.querySelector("[data-knf-custom-color]"); if (cw) cw.hidden = false;
      const inp = input(); if (inp) { const h = window.knfPalHex(inp.value); if (h) inp.dataset.hex = h; else delete inp.dataset.hex;
        // wer3: nazwa z palety jest zaznaczona - wpisany kod ja zastepuje, zamiast doklejac sie na koncu
        setTimeout(() => { inp.focus(); if (inp.dataset.plFor && inp.value === inp.dataset.plFor) inp.select(); }, 50); }   // tu klawiatura jest pozadana - klient wpisuje kod
    }
    updatePick();
  }

  function render() {
    if (!data || !data[tab]) { grid.innerHTML = `<p class="knf__hint">${T.err || "Nie udało się wczytać palety. Wpisz kod w zakładce „NCS / inny kod”."}</p>`; return; }
    const P = data[tab], items = P.items.filter(it => it.a !== false);
    const present = new Set(items.map(it => it.g).filter(Boolean));
    const fams = (data.order || [...present]).filter(f => present.has(f));
    const noteEl = panel.querySelector("[data-knf-pal-note]");
    if (noteEl) noteEl.textContent = (P.note && (P.note[locale] || P.note.pl)) || "";
    const FL = T.fam || {};
    const t = norm(q && q.value);
    // widok startowy: rodziny barw (kafelek = pasek odcieni od jasnego do ciemnego + liczba); kolory po wyborze rodziny albo wpisaniu kodu
    const famView = !fam && !t;
    famWrap.hidden = famView;
    grid.classList.toggle("is-fams", famView);
    if (famView) {
      grid.innerHTML = fams.map(f => {
        const its = items.filter(x => x.g === f).sort((a, b) => lum(b.h) - lum(a.h)), n = its.length;
        const sw = [0, .25, .5, .75, 1].map(pp => its[Math.round(pp * (n - 1))]).filter(Boolean);
        return `<button type="button" class="knf__pal-famtile" data-f="${f}"><span>${sw.map(x => `<i style="background:${x.h}"></i>`).join("")}</span><b>${FL[f] || f}</b><small>${n}</small></button>`;
      }).join("");
      updatePick();
      return;
    }
    famWrap.innerHTML = [`<button type="button" class="knf__pal-f knf__pal-f--all" aria-pressed="${!!t}" data-f="">${T.fams || "Wszystkie rodziny"}</button>`]
      .concat(fams.map(f => `<button type="button" class="knf__pal-f" aria-pressed="${!t && fam === f}" data-f="${f}"><i style="background:${(items.find(x => x.g === f) || {}).h}"></i>${FL[f] || f}</button>`)).join("");
    { const a = famWrap.querySelector('[aria-pressed="true"]'); if (a && famWrap.scrollWidth > famWrap.clientWidth) famWrap.scrollLeft = Math.max(0, a.offsetLeft - famWrap.offsetLeft - 16); }   // wer3: aktywna rodzina widoczna na telefonie
    const shown = items.filter(it => (t || !fam || it.g === fam) && (!t || norm(it.k).includes(t) || norm(nameOf(it)).includes(t) || norm(it.k).replace(/\D/g, "").includes(t.replace(/\D/g, "") || "§")));
    const cur = norm(input() ? input().value : "");
    grid.innerHTML = shown.length ? shown.map(it => {
      const on = cur && cur === norm(label(tab, it));
      return `<button type="button" class="knf__pal-c" role="radio" aria-checked="${on}" data-k="${it.k}" data-h="${it.h}" data-l="${label(tab, it).replace(/"/g, "&quot;")}" data-pl="${labelPl(tab, it).replace(/"/g, "&quot;")}" title="${label(tab, it).replace(/"/g, "&quot;")}"><span style="background:${it.h}"></span><b>${it.k.replace(/^(RAL|ICA|No\.|S)\s+/, "")}</b>${nameOf(it) ? `<em>${nameOf(it)}</em>` : ""}</button>`;
    }).join("") : `<p class="knf__hint">${T.none || "Brak kolorów dla tego wyszukiwania."}</p>`;
    updatePick();
  }

  function updatePick() {
    if (!pick) return;
    const inp = input(), v = inp && inp.value, h = inp && inp.dataset.hex;
    const on = !!(v && h && !tabs.hidden && customTile() && customTile().classList.contains("is-active"));   // fornir/sklejka: zakladki ukryte = bez karty koloru
    pick.hidden = !on;
    // wer2 24.09: w „Podstawowe” i „NCS / inny kod” karta stoi pod zakladkami (panel palety jest wtedy ukryty)
    const home = tab === "ral" || tab === "ica" || tab === "fb" ? grid : tabs;
    if (pick.previousElementSibling !== home) home.after(pick);
    if (on) pick.innerHTML = `<span style="background:${esc(h)}"></span><div><strong>${esc(v)}</strong><small>${T.note || "Kolor na ekranie jest poglądowy. Przed zamówieniem sprawdź go na próbce."}</small></div>`;
  }

  function choose(btn) {
    const tile = customTile(), inp = input();
    if (!tile || !inp) return;
    tile.dataset.knfNoFocus = "1";
    if (!tile.classList.contains("is-active")) tile.click();
    delete tile.dataset.knfNoFocus;
    inp.value = btn.dataset.l;
    inp.dataset.hex = btn.dataset.h;
    inp.dataset.pl = btn.dataset.pl; inp.dataset.plFor = btn.dataset.l;   // _pl_summary po polsku (konfigurator-natywny.js)
    inp.dispatchEvent(new Event("input", { bubbles: true }));
    inp.blur();
    lastPicked = btn.dataset.l;
    grid.querySelectorAll(".knf__pal-c").forEach(b => b.setAttribute("aria-checked", String(b === btn)));
    updatePick();
  }

  tabs.addEventListener("click", e => { const b = e.target.closest("[data-pal]"); if (b && b.dataset.pal !== tab) setTab(b.dataset.pal); });
  famWrap.addEventListener("click", e => { const b = e.target.closest("[data-f]"); if (!b) return; fam = b.dataset.f; if (q) q.value = ""; render(); });
  if (q) q.addEventListener("input", () => render());
  grid.addEventListener("click", e => {
    const f = e.target.closest(".knf__pal-famtile"); if (f) { fam = f.dataset.f; render(); return; }
    const b = e.target.closest(".knf__pal-c"); if (b) choose(b);
  });

  // wybor koloru z palety podstawowej = powrot do zakladki „Podstawowe”; reczna zmiana tekstu kasuje zapamietany hex
  root.addEventListener("click", e => {
    const c = e.target.closest(".knf__color");
    if (c && c.dataset.color && c.dataset.color !== "__custom__" && tab !== "base") setTab("base", true);
    else if (c) updatePick();
  });
  root.addEventListener("input", e => {
    if (e.target === input() && e.isTrusted) {
      const tile = customTile();
      if (tile && !tile.classList.contains("is-active") && e.target.value.trim()) {   // pierwszy znak w zakladce kodu = tryb „Dowolny kolor”
        tile.dataset.knfNoFocus = "1"; tile.click(); delete tile.dataset.knfNoFocus;
        e.target.dispatchEvent(new Event("input", { bubbles: true }));
      }
      const h = window.knfPalHex(e.target.value); if (h) e.target.dataset.hex = h; else delete e.target.dataset.hex;
    }
    if (e.target === input()) updatePick();   // takze po przywroceniu koloru przy zmianie stylu (zdarzenie z kodu)
  });

  // zakladki tylko dla lakieru (fornir i sklejka nie maja kolorow): konfigurator chowa wtedy siatke kolorow
  const sync = () => {
    const lakier = colorsWrap && colorsWrap.style.display !== "none" && !!colorsWrap.querySelector('.knf__color[data-color]');
    tabs.hidden = !lakier;
    if (!lakier) { panel.hidden = true; fs.classList.remove("knf--pal-list", "knf--pal-code"); if (tab !== "base") tab = "base"; }
    else if (tab === "base") tabs.querySelectorAll("[data-pal]").forEach(b => b.setAttribute("aria-selected", String(b.dataset.pal === "base")));
    updatePick();   // 24.09: karta koloru stoi poza panelem - na fornirze i sklejce musi zniknac razem z zakladkami
  };
  new MutationObserver(sync).observe(colorsWrap, { attributes: true, attributeFilter: ["style"], childList: true });
  sync();

  // przywrocona konfiguracja z kolorem z palety: otworz wlasciwa zakladke i zaznacz kolor
  const restore = () => {
    const tile = customTile(), inp = input();
    if (!tile || !inp || !tile.classList.contains("is-active") || !inp.value) return;
    loadFor(/^ncs\s/i.test(inp.value) ? "ncs" : "ral").then(d => {
      if (!d) return;
      const t = norm(inp.value);
      for (const key of LIST) {
        const hit = ((d[key] && d[key].items) || []).find(it => norm(label(key, it)) === t);
        if (hit) {
          inp.dataset.hex = window.knfPalHex(inp.value); inp.dataset.pl = labelPl(key, hit); inp.dataset.plFor = inp.value.trim(); setTab(key, true); inp.dispatchEvent(new Event("change", { bubbles: true })); return;
        }
      }
      setTab("code", true);
      const h = window.knfPalHex(inp.value);
      if (h) { inp.dataset.hex = h; inp.dispatchEvent(new Event("change", { bubbles: true })); }
    });
  };
  (window.requestIdleCallback || (f => setTimeout(f, 1200)))(restore);
})();
